import React, { useEffect, useState } from 'react';
import { theme } from 'antd';
import TitleBar from 'components/TitleBar';
import { TitleList } from 'store/ducks/globalTypes';
import { CardNode } from 'components/CardComponent/CardNode';
import ReactFlow from 'reactflow';
import { useTreeFlowData } from 'constants/dataCards';
import 'reactflow/dist/style.css';
import { useTranslation } from 'react-i18next';
import * as Styled from '../Layout.styled';

export default function DataEntryFlow() {
  const { useToken } = theme;
  const { token } = useToken();
  const { t } = useTranslation();
  const { nodes, edges } = useTreeFlowData();

  const nodeTypes = {
    cardNode: CardNode,
  };

  const useIsTouchDevice = () => {
    const [isTouch, setIsTouch] = useState(false);

    useEffect(() => {
      const mediaQuery = window.matchMedia('(pointer: coarse)');
      setIsTouch(mediaQuery.matches);

      const handler = (e: MediaQueryListEvent) => setIsTouch(e.matches);
      mediaQuery.addEventListener('change', handler);

      return () => mediaQuery.removeEventListener('change', handler);
    }, []);

    return isTouch;
  };

  const isTouchDevice = useIsTouchDevice();

  return (
    <Styled.StyledLayout token={token}>
      <TitleBar title={t(TitleList.DATA_ENTRY)} />
      <Styled.ReactFlowDiv>
        <ReactFlow
          nodes={nodes}
          edges={edges}
          nodeTypes={nodeTypes}
          nodesDraggable={false}
          panOnDrag={isTouchDevice}
          panOnScroll={false}
          zoomOnScroll={isTouchDevice}
          zoomOnPinch={isTouchDevice}
          zoomOnDoubleClick={false}
          elementsSelectable={true}
          nodesConnectable={false}
          fitView
          fitViewOptions={{ padding: 0.2 }}
          attributionPosition="bottom-left"
          minZoom={0.6}
          maxZoom={1.2}
          proOptions={{ hideAttribution: true }}
        />
      </Styled.ReactFlowDiv>
    </Styled.StyledLayout>
  );
}
